module.exports = file => () => import('@/view/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/router/_import_production.js